<!-- position-relative is needed to not overlap main content. Otherwise the footer would be sticky. -->
<div class="footer container-fluid position-relative fixed-bottom d-flex gap-3 justify-content-between align-items-center">
  <div class="footer-brand me-2">
    <img ngSrc="assets/images/rforce-logo.svg" priority alt="R-Force Logo" i18n-alt width="177" height="155"
         [ngbPopover]="versionInfo" autoClose="outside" container="body"/>
  </div>
  <div class="d-none d-sm-block">
    <div class="btn-group btn-group-sm" role="group"
         aria-label="Theme Selection" i18n-aria-label="@@color-scheme.selection.title">
      <input type="radio" class="btn-check" name="themeLight" id="themeLight" autocomplete="off"
             [checked]="themeMode() === 'light'" (change)="setThemeMode('light')">
      <label class="btn btn-outline-primary" for="themeLight" container="body"
             ngbTooltip="Light Theme" i18n-ngbTooltip="@@color-scheme.light.title">
        <i rfBsIcon="sun"></i>
      </label>
      <input type="radio" class="btn-check" name="themeSystem" id="themeSystem" autocomplete="off"
             [checked]="themeMode() === 'auto'" (change)="setThemeMode('auto')">
      <label class="btn btn-outline-primary" for="themeSystem" container="body"
             ngbTooltip="System Theme" i18n-ngbTooltip="@@color-scheme.system.title">
        <i rfBsIcon="circle-half"></i>
      </label>
      <input type="radio" class="btn-check" name="themeDark" id="themeDark" autocomplete="off"
             [checked]="themeMode() === 'dark'" (change)="setThemeMode('dark')">
      <label class="btn btn-outline-primary" for="themeDark" container="body"
             ngbTooltip="Dark Theme" i18n-ngbTooltip="@@color-scheme.dark.title">
        <i rfBsIcon="moon"></i>
      </label>
    </div>
  </div>
  <div class="d-block d-sm-none">
    <div ngbDropdown [placement]="['top-start', 'top-end']" container="body">
      <button type="button" class="btn btn-sm btn-outline-primary" id="themeSelectionDropDown"
              ngbDropdownToggle aria-label="Theme Selection" i18n-aria-label="@@color-scheme.selection.title">
        @switch (themeMode()) {
          @case ('light') {
            <i rfBsIcon="sun"></i>
            <span i18n="@@color-scheme.light.title" class="visually-hidden">Light Theme</span>
          }
          @case ('dark') {
            <i rfBsIcon="moon"></i>
            <span i18n="@@color-scheme.dark.title" class="visually-hidden">Dark Theme</span>
          }
          @case ('auto') {
            <i rfBsIcon="circle-half"></i>
            <span i18n="@@color-scheme.system.title" class="visually-hidden">System Theme</span>
          }
        }
      </button>
      <div ngbDropdownMenu aria-labelledby="themeSelectionDropDown">
        <button type="button" ngbDropdownItem class="d-flex gap-2" [class.active]="themeMode() === 'light'"
                (click)="setThemeMode('light')">
          <i rfBsIcon="sun"></i><span i18n="@@color-scheme.light.title">Light Theme</span>
        </button>
        <button type="button" ngbDropdownItem class="d-flex gap-2" [class.active]="themeMode() === 'auto'"
                (click)="setThemeMode('auto')">
          <i rfBsIcon="circle-half"></i><span i18n="@@color-scheme.system.title">System Theme</span>
        </button>
        <button type="button" ngbDropdownItem class="d-flex gap-2" [class.active]="themeMode() === 'dark'"
                (click)="setThemeMode('dark')">
          <i rfBsIcon="moon"></i><span i18n="@@color-scheme.dark.title">Dark Theme</span>
        </button>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-center align-items-center gap-2 gap-sm-3 text-center small">
    <a href="https://www.bactoforce.com/legal-notice/" target="_blank" class="text-break lh-1" i18n>Legal Notice</a>
    <span class="vr opacity-50"></span>
    <a href="https://www.bactoforce.com/privacy-notice/" target="_blank" class="text-break lh-1" i18n>Privacy Notice</a>
  </div>
  <ng-template #versionInfo>
    <div class="d-flex flex-column gap-1">
      <div class="d-inline-flex flex-row justify-content-between align-items-baseline gap-2">
        <small class="fw-bold" i18n="@@version-info.frontend.title">Frontend Version</small>
        <code>{{ frontendVersion }}</code>
      </div>
      @if (backendVersion(); as backendVersion) {
        <div class="d-inline-flex flex-row justify-content-between align-items-baseline gap-2">
          <small class="fw-bold" i18n="@@version-info.backend.title">Backend Version</small>
          <code>{{ backendVersion }}</code>
        </div>
      }
    </div>
  </ng-template>
</div>
